import { unnest } from 'ramda';

import { camelize } from './common';

export enum ContentTypes {
  jsonDefault = 'application/json',
  json = 'application/json; charset=utf-8',
  vndJson = 'application/vnd.s.v1+json; charset=utf-8',
  vndJsonLegacy = 'application/vnd.softswiss.v1+json; charset=utf-8',
  vndJsonV2 = 'application/vnd.s.v2+json; charset=utf-8',
  vndJsonV2Legacy = 'application/vnd.softswiss.v2+json; charset=utf-8',
}

const contentTypes = [
  ContentTypes.jsonDefault,
  ContentTypes.json,
  ContentTypes.vndJson,
  ContentTypes.vndJsonLegacy,
  ContentTypes.vndJsonV2,
  ContentTypes.vndJsonV2Legacy,
];

export function getResponseCamelization(
  data: any,
  headers?: Headers,
  blacklists?: string[][]
): any {
  if (
    headers != null &&
    headers.has('content-type') &&
    contentTypes.includes(headers.get('content-type') as ContentTypes)
  ) {
    let jsonResp;

    if (typeof data === 'string') {
      try {
        jsonResp = JSON.parse(data);
      } catch (e) {
        return {};
      }
    } else {
      jsonResp = data;
    }

    return camelize(jsonResp, blacklists);
  }

  return data;
}

type Request<T, A extends any[]> = {
  fn: (...args: A) => Promise<T>;
  args?: A;
};

export const parallel = (
  ...requests: Request<any, any>[]
): Request<any, any> => {
  return {
    fn: async () =>
      await Promise.all(requests.map(({ fn, args = [] }) => fn(...args))),
  };
};

export const apiPipe = async (
  ...requests: Request<any, any>[]
): Promise<any[]> => {
  const results: any[] = [];

  const executeRequest = async ({ fn, args = [] }: Request<any, any>) => {
    try {
      const result = await fn(...args);
      results.push(result);
    } catch (error) {
      results.push({ error });
    }
  };

  for (const request of requests) {
    await executeRequest(request);
  }

  return unnest(results);
};
